import React, { useEffect, useState, createRef } from 'react'
import { Container, Row, Col, Form, Button, Card, FormSelect } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { editUserCandidate } from '../../actions/usersActions'
import Swal from 'sweetalert2'
import Select from "react-select"
import { getCandidate, getCandidateProfileStatus } from '../../actions/candidatesActions'
import { activateOrDeactivateCandidate } from '../../actions/usersActions'

import { useNavigate, useParams } from 'react-router-dom'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import values from '../../components/values.json'

import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, ContentState, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

export default function Profile() {
    const {id: candidateId} = useParams() || {}
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const fileRef = createRef("<HTMLInputElement>")
    const curriculumFileRef = createRef("<HTMLInputElement>")
    const recommendationLetterFileRef = createRef("<HTMLInputElement>")
    
    const {candidate, candidateuser, candidateStatus} = useSelector(state=>state.candidates)
    const {resultuser} = useSelector(state=>state.users)

    const [valuesSelect, setValuesSelect] = useState({options: values?.map(value => {
        return {label: t('values.'+value), value: value}
    }), selected : []})
    const [formState, setFormState] = useState({})

    const [provinceAux, setProvinceAux] = useState({label: '', value: ''});
    const [townAux, setTownAux] = useState({label: '', value: ''});

    const [townsAux, setTownsAux] = useState([]);

    const [imageAux, setImage] = useState(null)

    const [curriculumAux, setCurriculum] = useState(null)

    const [recommendationLetterAux, setRecommendationLetter] = useState(null)

    const [coverLetterEditorState, setCoverLetterEditorState] = useState(EditorState.createEmpty())

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getCandidate(candidateId || client?.id))
        }
    },[dispatch, t, client])

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSelectTownChange = (target)=>{
        setFormState({
            ...formState,
            'town': target.value
        })
        setTownAux(towns.filter(town => town.value === target.value && target.parent_value === town.parent_value))

    }

    const handleSelectProvinceChange = (target)=>{
        setFormState({
            ...formState,
            'province': target.value,
            'town': ''
        })
        setProvinceAux(provinces.filter(province => province.value === target.value))
        setTownAux({label: '', value: ''})
        setTownsAux(towns.filter(town => town.parent_value === target.value))
    }

    const handleSelectValuesChange = (values)=>{
        if(values.length < 6){
            setValuesSelect({...valuesSelect, selected : values})
            setFormState({
                ...formState,
                'values': values.map(valor => {
                    return valor.value
                })
            })
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.maxvaluesselected')
            })
        }
    }

	const changeImage = (e) => {
		setImage(e.target.files[0])
	}

    const handleAdd = async(e) => {
        e.preventDefault()
        if (valuesSelect.selected.length === 0) {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.completevalues')
            })
            return
        }

        if(formState.town !== null && formState.province !== null && formState.town !== '' && formState.province !== '' && formState.town !== undefined && formState.province !== undefined){
            dispatch(editUserCandidate(imageAux, curriculumAux, recommendationLetterAux, formState, candidateId || client?.id))
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.pleasecomplete')
            })
        }
    }

    const handleCoverLetterChange = (coverLetter) => {
        setCoverLetterEditorState(coverLetter)

        setFormState({
            ...formState,
            cover_letter: draftToHtml(convertToRaw(coverLetter.getCurrentContent()))
        })
    }

    const handleActivateOrDeactivate = async(e) => {
        e.preventDefault()

        dispatch(activateOrDeactivateCandidate(candidateId || client?.id))
    }

    useEffect(() => {
        if(candidate){
            setFormState({
                firstname: candidate.firstname,
                lastname: candidate.lastname,
                birthdate: candidate.birthdate?.substring(0, 10),
                phone: candidate.phone,
                town: candidate.town,
                province: candidate.province,
                linkedin: candidate.linkedin,
                cover_letter: candidate.cover_letter,
                values: candidate.values || [],
                email: candidateuser?.email,
                marketing: candidate.marketing,
                notifications: candidateuser?.notifications,
                image: candidateuser?.image,
                sex: candidate?.sex || 'M'
            })

            setValuesSelect({...valuesSelect, selected: candidate.values.map(valor =>{
                return {label: t('values.'+valor), value: valor}
            })})

            if(candidate.province !== null && candidate.town !== null){
                setProvinceAux(provinces.filter(province => province.value === candidate.province))
                setTownsAux(towns.filter(town => town.parent_value === candidate.province))
                setTownAux(towns.filter(town => town.value === candidate.town && formState.province === candidate.province))
            }else{
                setProvinceAux(null)
                setTownAux(null)
            }

			setImage(candidate.image)

            if (candidate.cover_letter) {
                const blocksFromHtml = htmlToDraft(candidate.cover_letter)
                const { contentBlocks, entityMap } = blocksFromHtml

                setCoverLetterEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap)))
            }
        }
    // eslint-disable-next-line
    }, [candidate, candidateuser])

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    dispatch(getCandidate(candidateId || client?.id))
                    dispatch(getCandidateProfileStatus(candidateId || client?.id))
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('users.candidateedit')
                    })
                    sessionStorage.setItem('firsttime', 'false')
                    if (candidateStatus !== 'completed' && parseInt(candidateStatus) === 1) {
                        navigate('/candidate/profile/officialtitles')
                    } else {
                        navigate('/candidate/dashboard')
                    }
                    break;
                case 'activateUserSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('users.activateUserSuccess')
                    })
                    break;
                case 'deactivateUserSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('users.deactivateUserSuccess')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-4'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/menus/user.svg" alt="Icono Perfil" />
                        <h1 className='ms-2 m-0'>{t('config.candidate.profile')}</h1>
                    </Col>
                </Row>
                <Form onSubmit={handleAdd}>
                    <Row className="mt-2">
                        <Col>
                            <Card className='mb-5 sombra'>
                                <Card.Body className='px-5 pt-5'>
                                    <Row>
                                        <Col>
                                            {
                                                candidate?.sex === 'F'
                                                    ?
                                                        <h3>{t('dashboard.candidate.welcomeFemale')} {candidate?.firstname} {candidate?.lastname}</h3>
                                                    :
                                                        <h3>{t('dashboard.candidate.welcomeMale')} {candidate?.firstname} {candidate?.lastname}</h3>
                                            }
                                            {t('dashboard.candidate.subwelcome')}
                                        </Col>
                                    </Row>
                                    <Row className="mt-3 mb-4">
                                        <Col xs='12' className='d-flex align-items-center'>
                                            <div className='avatar me-2'>
                                                {imageAux
                                                    ?
                                                        <img className="img-profile" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
                                                    :
                                                        formState.image
                                                            ?
                                                                <img className="img-profile" alt="Preview" src={typeof formState.image === 'string' ? formState.image : URL.createObjectURL(formState.image)} />
                                                            :
                                                                <img className='img-profile' alt="Avatar" src="/images/avatar-empty.svg" />
                                                }
                                                <input
                                                    className='custom-file-input'
                                                    style={{ display: 'none' }}
                                                    ref={fileRef}
                                                    type="file"
                                                    name="myImage"
                                                    onChange={changeImage}
                                                />
                                            </div>
                                            <div className="cursor" onClick={() => fileRef.current?.click()}>{t('users.image')}</div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className='mb-2'>
                                            <Form.Label htmlFor='sex'>{t('users.sex')} *</Form.Label>
                                            <FormSelect
                                                name='sex'
                                                value={formState.sex || 'M'}
                                                onChange={handleInputChange}
                                                required
                                                className='form-control'
                                            >
                                                <option value="M">{t('users.male')}</option>
                                                <option value="F">{t('users.female')}</option>
                                            </FormSelect>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='firstname'>{t('users.firstname')} *</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='firstname'
                                                value={formState.firstname ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='lastname'>{t('users.lastname')} *</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='lastname'
                                                value={formState.lastname ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='birthdate'>{t('users.birthdate')} *</Form.Label>
                                            <Form.Control
                                                type='date'
                                                name='birthdate'
                                                value={formState.birthdate ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='phone'>{t('users.phone')} *</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='phone' 
                                                value={formState.phone ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="mt-2 mb-0">
                                            <Form.Label htmlFor='province'>{t('users.province')} *</Form.Label>
                                            <Select
                                                className="select" 
                                                name='province'
                                                options={provinces.sort((a, b) => {
                                                    if (a.label < b.label) {
                                                        return -1
                                                    }
                                                    if (a.label > b.label) {
                                                        return 1
                                                    }
                                                    return 0
                                                })}
                                                value={provinceAux || null}
                                                onChange={(e) => handleSelectProvinceChange(e)}
                                                required
                                            />
                                            <input
                                                tabIndex={-1}
                                                autoComplete="off"
                                                style={{ opacity: 0, height: 0 }}
                                                value={formState.province || ''}
                                                required
                                                readOnly
                                            />
                                        </Col>
                                        <Col xs='12' lg='6' className="mt-2 mb-0">
                                            <Form.Label htmlFor='town'>{t('users.town')} *</Form.Label>
                                            <Select
                                                className="select" 
                                                name='town'
                                                options={townsAux}
                                                value={townAux || null}
                                                onChange={(e) => handleSelectTownChange(e)}
                                                required
                                            />
                                            <input
                                                tabIndex={-1}
                                                autoComplete="off"
                                                style={{ opacity: 0, height: 0 }}
                                                value={formState.town || ''}
                                                required
                                                readOnly
                                            />
                                        </Col>
                                    </Row>
                                    {
                                        client?.rol === "Superadmin"
                                        ?
                                            <Row>
                                                <Col xs='12' lg='6' className="my-2">
                                                    <Form.Label>{t('signin.email')}</Form.Label>
                                                    <Form.Control
                                                        type='email'
                                                        name='email'
                                                        value={formState.email ||  ''}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </Col>
                                                <Col xs='12' lg='6' className="my-2">
                                                    <Form.Label>{t('signin.password')}</Form.Label>
                                                    <Form.Control
                                                        type='password'
                                                        name='password'
                                                        value={formState.password ||  ''}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                </Col>
                                            </Row>
                                        :
                                            <></>
                                    }
                                    <Row>
                                        <Col className="my-2">
                                            <Form.Label htmlFor='linkedin'>{t('users.linkedin')}</Form.Label>
                                            <Form.Control
                                                type='url'
                                                name='linkedin' 
                                                value={formState.linkedin ||  ''}
                                                onChange={handleInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="my-2">
                                            <Form.Label htmlFor='valores'>{t('users.choosevalues')} *</Form.Label>
                                            <Select
                                                className="select"
                                                name='valores'
                                                options={valuesSelect?.options}
                                                value={valuesSelect?.selected?.sort((a, b) => {
                                                        if (a.label < b.label) {
                                                            return -1
                                                        }
                                                        if (a.label > b.label) {
                                                            return 1
                                                        }
                                                        return 0
                                                    })}
                                                onChange={handleSelectValuesChange}
                                                isMulti
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="my-2">
                                            <Form.Label htmlFor='myFile'>{t('users.cover_letter')}</Form.Label>
                                            <Editor
                                                toolbar={{
                                                    options: ['inline', 'list', 'textAlign', 'link'],
                                                    inline: { options: ['bold', 'italic', 'underline'] },
                                                    list: { options: ['unordered', 'ordered'] },
                                                    textAlign: { options: [] },
                                                    link: { options: ['link', 'unlink'] }
                                                }}
                                                editorState={coverLetterEditorState}
                                                onEditorStateChange={handleCoverLetterChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={6} className='my-2'>
                                            <div className='my-2'>
                                                <Form.Label>{t('profile.candidate.curriculum')} *</Form.Label>
                                                <Form.Control
                                                    type='file'
                                                    name='curriculum'
                                                    onChange={(e) => {setCurriculum(e.target.files[0])}} ref={curriculumFileRef}
                                                    required={!candidate?.curriculumUrl}
                                                />
                                            </div>
                                            {
                                                candidate?.curriculumUrl &&
                                                    <div className='bloque-adjuntos d-flex justify-content-between align-items-center'>
                                                        <div className='d-flex align-items-center'>
                                                            <img src="/images/cv.svg" className='w-65px me-3' alt="cv"/>
                                                            <h4 className='fw-bold m-0'>{t('profile.candidate.curriculum')}</h4>
                                                        </div>
                                                        <div>
                                                            <a href={candidate?.curriculumUrl} download target="_blank" rel="noreferrer"><i className='fas fa-download'/></a>
                                                        </div>
                                                    </div>
                                            }
                                        </Col>
                                        <Col xs={12} md={6} className='my-2'>
                                            <div className='my-2'>
                                                <Form.Label>{t('profile.candidate.recommendationLetter')}</Form.Label>
                                                <Form.Control
                                                    type='file'
                                                    name='recommendationLetter'
                                                    onChange={(e) => {setRecommendationLetter(e.target.files[0])}}
                                                    ref={recommendationLetterFileRef}
                                                />
                                            </div>
                                            {
                                                candidate?.recommendationLetterUrl &&
                                                    <div className='bloque-adjuntos d-flex justify-content-between align-items-center'>
                                                        <div className='d-flex align-items-center'>
                                                            <img src="/images/recommendation-letter.svg" className='w-65px me-3' alt="recommendation-letter"/>
                                                            <h4 className='fw-bold'>{t('profile.candidate.recommendationLetter')}</h4>
                                                        </div>
                                                        <div>
                                                            <a href={candidate?.recommendationLetterUrl} download target="_blank" rel="noreferrer"><i className='fas fa-download'/></a>
                                                        </div>
                                                    </div>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='4'>
                                            <Button type="button" className="btn-secondary w-100 my-2" onClick={handleActivateOrDeactivate}>{candidateuser?.active ? t('global.deactivate') : t('global.activate')}</Button>
                                        </Col>
                                        <Col xs='12' lg='4'>
                                            <Button type="submit" className="btn-primary w-100 my-2">{candidateStatus === '1' ? t('profile.candidate.saveAndContinue') : t('config.candidate.updateuser')}</Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Form>
            </Container>
        </>
    )
}